import React, { Component, Fragment } from 'react'
import {
    Button,
    Form,
    Input,
    Label,
    Modal, ModalBody, ModalFooter,
    ModalHeader
} from 'reactstrap'
import autobind from 'autobind-decorator'
import { connect } from 'react-redux'
import * as checkpoints from 'catalog/actions/checkpoints'

@connect(
    state => ({
        checkpointList: state.categories.checkpointList,
        checkpointListLoading: state.categories.checkpointListLoading
    }),
    dispatch => ({
        addCheckpoint: (name) => dispatch(checkpoints.addCheckpoint(name))
    })
)
export default class NewCheckpoint extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isOpen: false,
            newCheckpointName: ''
        }
    }

    @autobind
    toggle() {
        const isOpen = !this.state.isOpen
        this.setState({ isOpen })
    }

    @autobind
    changeNewCheckpointName(e) {
        this.setState({ newCheckpointName: e.target.value })
    }

    @autobind
    confirm() {
        this.props.addCheckpoint(this.state.newCheckpointName)
        this.toggle();
    }

    render() {
        return (
            <Fragment>
                <Button
                    color='primary' title="Checkpoint hinzufügen"
                    onClick={this.toggle}
                >
                    <i className='fa fa-plus'> </i> Checkpoint hinzufügen
                </Button>
                <Modal isOpen={this.state.isOpen}>
                    <ModalHeader>
                        Checkpoint hinzufügen
            </ModalHeader>
                    <ModalBody>
                        <Form>
                            <Label>
                                Bezeichnung
                    </Label>
                            <Input value={this.state.newCheckpointName} onChange={this.changeNewCheckpointName} />
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button color='danger'
                            onClick={this.confirm}>Bestätigen</Button>
                        <Button color='default'
                            onClick={this.toggle}>Abbrechen</Button>
                    </ModalFooter>
                </Modal>
            </Fragment>
        )
    }
}